import { TextField } from 'components/Fields';
import { KoobTooltip, KoobButton } from '@koob/ui';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { LocaleSwitcher } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Stack } from '@koob/margaret';
import { Text } from 'ui';

const ExperienceThemeForm = ({
  onSubmit,
  theme,
  queryLocale,
  updateQueryLocale,
  disabledCreate = false,
}) => {
  const { t } = useTranslation('experienceTheme');

  return (
    <Formik
      initialValues={{
        displayName: theme?.displayName ?? '',
      }}
      enableReinitialize
      onSubmit={onSubmit}
      validationSchema={Yup.object().shape({
        displayName: Yup.string().required(t('errors:required')),
      })}
    >
      {({ isSubmitting, dirty }) => (
        <Form>
          <Stack direction="column" gutterSize={1} size="full" alignX="stretch">
            <Stack
              size="full"
              alignX="space-between"
              alignY="center"
              gutterSize={1}
            >
              <Text type="h1">
                {t(Boolean(theme) ? theme?.displayName : 'newTheme')}
              </Text>
              <LocaleSwitcher
                queryLocale={queryLocale}
                updateQueryLocale={updateQueryLocale}
                disabled={Boolean(theme) && dirty}
              />
            </Stack>
            <TextField label={t('name')} name="displayName" />
            <Stack gutterSize={1}>
              <KoobTooltip disabled={!disabledCreate} tip={t('selectEnglish')}>
                <KoobButton
                  type="submit"
                  variant="primary"
                  loading={isSubmitting}
                  disabled={disabledCreate}
                >
                  {Boolean(theme) ? t('misc:saveChanges') : t('create')}
                </KoobButton>
              </KoobTooltip>
              <KoobButton variant="secondary" type="button" asChild>
                <Link to="/settings/experiences/themes" state={queryLocale}>
                  {t('misc:cancel')}
                </Link>
              </KoobButton>
            </Stack>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default ExperienceThemeForm;
